import WeighInEditor from './WeighInEditor';
import createProtocol from './createProtocol';
import { Layout } from '../common';
import SessionSelect from '../../components/SessionSelect';
import { Form } from '../../components';
import ormActions from '../../orm/actions';
import {
  liftsSelector,
  groupsSelector,
  sessionsSelector,
  protocolsSelector,
} from '../../orm/selectors';
import { bickActions } from '../../common';

import { connect } from 'react-redux';
import React, { Component } from 'react';
import { find, get, pick } from 'lodash';

// TODO: Coach pass amounts, second lifter being weighed-in first?
class WeighIn extends Component {
  state = {
    session: get(find(this.props.sessions, 'number'), 'primaryKey', []),
  };

  save = (entry, values, weighInDeclarations) => {
    const { actions } = this.props;
    actions.weighInDatum.upsert({ entry, ...values });

    for (const [lift, weight] of Object.entries(weighInDeclarations))
      actions.weighInDeclaration.upsert({ entry, lift, weight });
  };

  clear = entry => {
    const { lifts, actions } = this.props;

    actions.weighInDatum.destroy(entry);
    for (const lift of lifts)
      actions.weighInDeclaration.destroy([entry, lift.primaryKey]);
  };

  complete = (session, rows) => {
    const { actions } = this.props;
    createProtocol(session, rows, actions);
  };

  onSessionChange = (event, { value }) => {
    this.setState({ session: value });
  };

  render() {
    const { app, route, lifts, groups, sessions, protocols } = this.props;
    const { session } = this.state;

    const sessionOptions = sessions.map(session => ({
      ...session,
      disabled: !session.entries.length,
    }));

    const currentSession = find(sessions, { primaryKey: session });
    const currentProtocol = find(protocols, {
      session: get(currentSession, 'id'),
    });
    const isComplete = !!currentProtocol;

    const actions = pick(this, 'save', 'clear', 'complete');

    return (
      <Layout app={app} route={route}>
        <h1>Weigh-in</h1>
        <Form>
          <Form.Group>
            <Form.Field
              label="Session"
              control={SessionSelect}
              value={session}
              options={sessionOptions}
              onChange={this.onSessionChange}
              width={6}
            />
          </Form.Group>
        </Form>
        <hr />
        {currentSession && (
          <WeighInEditor
            id="weigh-in--weigh-in-editor"
            locked={isComplete}
            session={currentSession}
            actions={actions}
            meta={{ lifts, groups, sessions }}
          />
        )}
      </Layout>
    );
  }
}

WeighIn.slug = 'weigh-in';
WeighIn.title = 'Weigh-in';

const mapStateToProps = ({ orm }) => ({
  lifts: liftsSelector(orm),
  groups: groupsSelector(orm),
  sessions: sessionsSelector(orm),
  protocols: protocolsSelector(orm),
});

const mapDispatchToProps = dispatch => ({
  actions: bickActions(
    ormActions,
    [
      'weighInDatum',
      'weighInDeclaration',
      'protocol',
      'athlete',
      'declaration',
    ],
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WeighIn);



// WEBPACK FOOTER //
// ./src/pages/WeighIn/WeighIn.js